<xemex-page-header
  [title]="'sidebarMenu.settings' | translate"
  [withBackground]="true"
  [withTabBar]="true"
  [breadcrumbs]="[
    { label: 'sidebarMenu.home' | translate, routerLink: '/' },
    { label: 'sidebarMenu.settings' | translate },
  ]"
  [icon]="'settings'"
>
  <xemex-tab-bar
    [tabs]="SETTINGS_TABS"
    [defaultTab]="0"
    (tabChange)="onTabChange($event)"
  ></xemex-tab-bar>
</xemex-page-header>

@if (selectedTab === 'shipment-files') {
  <xemex-page-body>
    <xemex-shipment-files [user]="user"></xemex-shipment-files>
  </xemex-page-body>
}

@if (selectedTab === 'device-config-files') {
  <xemex-page-body>
    <xemex-device-config-files></xemex-device-config-files>
  </xemex-page-body>
}

@if (selectedTab === 'firmware-versions') {
  <xemex-page-body>
    <xemex-firmware-versions-page></xemex-firmware-versions-page>
  </xemex-page-body>
}

@if (selectedTab === 'initial-config-files') {
  <xemex-page-body>
    <xemex-initial-config-files></xemex-initial-config-files>
  </xemex-page-body>
}
